var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockUtglWeb = function SvgLockUtglWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Lock_UTGL_Web_svg__a)",
    fill: "#DC9B32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.32 17.32v-2.73c-.37-.18-.61-.61-.61-1.09 0-.72.58-1.31 1.29-1.31.74 0 1.29.58 1.29 1.31 0 .48-.24.91-.65 1.15l.03 2.67H8.3h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.93 21.07V8.41h3.08v-2.3C4.01 3.16 6.15.93 8.98.93c2.83 0 5.01 2.23 5.01 5.18v2.33h.54l2.54-.03v12.66H.93Zm14.76-1.41V9.82H2.32v9.85h13.37v-.01ZM12.63 8.41v-2.3c0-2.2-1.53-3.79-3.65-3.79s-3.6 1.59-3.6 3.79v2.3h7.25Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Lock_UTGL_Web_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.93 .93)",
    d: "M0 0h16.14v20.14H0z"
  })))));
};
export default SvgLockUtglWeb;